import React, { Component } from 'react';

class InfoComponent extends Component {
  render() {
    return (
      <>
        <p>This app was created by JIT and LO3 collab</p>
        <img height="200px" src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/III_LO_Gdynia-0.jpg/1280px-III_LO_Gdynia-0.jpg"></img>
      </>
    )
  }
}

export default InfoComponent